<footer class="govbook-footer">
	<div class="govbook-footer__pre-footer">
		<div class="govbook-container">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<ul class="menu menu--footer">
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/"
								>Ceremonies</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/ceremonies-at-redbridge-town-hall/"
								>Ceremonies at Redbridge Town Hall</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/ceremonies/naming-ceremonies/"
								>Naming ceremonies</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/registrars-fees/"
								>Registrars fees</a
							>
						</li>
						<li class="menu-item">
							<a
								target="_blank"
								class="footer-links"
								href="https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/give-notice-of-your-marriage-or-civil-partnership/"
								>Give notice of your marriage or civil partnership</a
							>
						</li>
					</ul>
				</div>

				<div class="col-sm-12 col-md-6">

          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.redbridge.gov.uk/contact-us/">Contact Redbridge Council</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.redbridge.gov.uk/terms-of-use/">Terms of use</a>
            </li>
            <li class="menu-item">
              <a target="_blank" class="footer-links"
                href="https://www.redbridge.gov.uk/about-the-council/privacy-and-data/privacy-notices/">Privacy notices</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
            </li>
          </ul>
					<h4>Contact us</h4>
					<a
						target="_blank"
						class="footer-links"
						href="https://eforms.redbridge.gov.uk/contact-us/"
						>Contact us online</a
					>
					<span class="footer-links">&nbsp;or call 020 8554 5000</span>
					<nav
						aria-labelledby="block-ecc-theme-gov-socialmedia-menu"
						id="block-ecc-theme-gov-socialmedia"
						class="block block-menu navigation navigation--social-media"
					>
						<h2
							class="visually-hidden"
							id="block-ecc-theme-gov-socialmedia-menu"
						>
							Social Media
						</h2>

						<ul
							class="menu menu--social-media justify-content-end justify-content-md-start mt-3"
						>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Facebook (opens in new window)"
									class="footer-links"
									href="https://www.facebook.com/RedbridgeCouncilOfficial/"
									class="social-link facebook"
									>Facebook</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="X (opens in new window)"
									class="footer-links"
									href="https://x.com/redbridgelive"
									class="social-link twitter"
									>X</a
								>
							</li>
							<li class="menu-item">
								<a
									target="_blank"
									aria-label="Instagram (opens in new window)"
									class="footer-links"
									href="https://www.instagram.com/redbridgecouncil/"
									class="social-link instagram"
									>Instagram</a
								>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>

	<div class="govbook-footer__footer">
		<div class="govbook-container">
			<div class="govbook-row">
				<div class="govbook-row__full">
					<div
						class="govbook-region govbook-region--footer region region-footer"
					>
						<div class="padding-horizontal">
							<div class="govbook-region__inner govbook-region__inner--footer">
								<div
									id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
									class="block block-localgov-core block-localgov-powered-by-block"
								>
									<span
										>Powered by
										<a
											target="_blank"
											aria-label="Bookinglab | GovBook (opens in new window)"
											class="footer-links"
											href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=ecc
                                            "
											>bookinglab | GovBook</a
										></span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
